import { Dismiss } from '@wix/wix-ui-icons-common';
import { sanitize } from 'dompurify';
import parse from 'html-react-parser';
import React from 'react';
import { t } from '../../../utils/i18n';
import s from './styles.scss';

const closeWidget = () => {
  window.Wix.closeWindow();
};

export default ({ siteOwnerEmail, onClickGotIt }: { siteOwnerEmail: string; onClickGotIt(): void }) => (
  <div className={s.bg}>
    <button data-hook="wcn-close-button" className={s.closeButton} aria-label="close" onClick={closeWidget}>
      <Dismiss />
    </button>
    <div data-hook="wcn-no-connected-payment-methods-title" className={s.title}>
      {t('paymentMethods.noConnectedProviders.title')}
    </div>
    <div data-hook="wcn-no-connected-payment-methods-description" className={s.description}>
      {parse(
        sanitize(
          t('paymentMethods.noConnectedProviders.description', {
            siteOwnerEmail,
          }),
        ),
      )}
    </div>
    <button data-hook="wcn-no-connected-payment-methods-button" className={s.button} onClick={onClickGotIt}>
      {t('paymentMethods.noConnectedProviders.button')}
    </button>
  </div>
);
